// extracted by mini-css-extract-plugin
module.exports = {"conclusionText":"_3zG1v","conclusionText_title":"_1h_jh","conclusionText_body":"_52uEB"};